// Central data-testid registry. Naming: kebab-case, describes function.
export const TID = {
  nav: {
    logo: "nav-logo",
    home: "nav-home",
    search: "nav-search",
    dashboard: "nav-dashboard",
    messages: "nav-messages",
    notifications: "nav-notifications",
    profile: "nav-profile",
    settings: "nav-settings",
    jobs: "nav-jobs",
    themeToggle: "nav-theme-toggle",
    login: "nav-login-link",
    signup: "nav-signup-cta",
    logout: "nav-logout-button",
    userMenu: "nav-user-menu",
    mobileToggle: "nav-mobile-toggle",
  },
  landing: {
    heroCta: "landing-hero-cta",
    heroSecondary: "landing-hero-secondary",
    forAuthors: "landing-for-authors",
    forReaders: "landing-for-readers",
    finalCta: "landing-final-cta",
  },
  auth: {
    email: "auth-email-input",
    password: "auth-password-input",
    displayName: "auth-display-name-input",
    roleAuthor: "auth-role-author",
    roleBetaReader: "auth-role-beta-reader",
    roleBoth: "auth-role-both",
    submit: "auth-submit-button",
    switchMode: "auth-switch-mode-link",
    demoAuthor: "auth-demo-author-button",
    demoReader: "auth-demo-reader-button",
    error: "auth-error-message",
  },
  dashboard: {
    root: "dashboard-root",
    switcher: "dashboard-role-switcher",
    tileProjects: "author-tile-projects",
    tileMessages: "author-tile-messages",
    tileFavorites: "author-tile-favorites",
    tileReviews: "author-tile-reviews",
    tilePortfolio: "author-tile-portfolio",
    tilePayments: "author-tile-payments",
    tileNotifications: "author-tile-notifications",
    tileJourney: "author-tile-journey",
    tileSettings: "author-tile-settings",
    tileAvailableJobs: "reader-tile-available-jobs",
    tileApplications: "reader-tile-applications",
    tileEarnings: "reader-tile-earnings",
    tileQuality: "reader-tile-quality",
    tileCertifications: "reader-tile-certifications",
  },
  profile: {
    root: "profile-root",
    edit: "profile-edit-button",
    save: "profile-save-button",
    cancel: "profile-cancel-button",
    displayName: "profile-display-name-input",
    headline: "profile-headline-input",
    bio: "profile-bio-input",
    location: "profile-location-input",
    genres: "profile-genres-input",
    styles: "profile-styles-input",
    languages: "profile-languages-input",
    experience: "profile-experience-input",
    availability: "profile-availability-select",
    favBooks: "profile-fav-books-input",
    pubBooks: "profile-pub-books-input",
    website: "profile-website-input",
    twitter: "profile-twitter-input",
    instagram: "profile-instagram-input",
    linkedin: "profile-linkedin-input",
    goodreads: "profile-goodreads-input",
    avatarUpload: "profile-avatar-upload",
    bannerUpload: "profile-banner-upload",
    bannerImage: "profile-banner-image",
  },
  settings: {
    root: "settings-root",
    theme: "settings-theme-select",
    largeText: "settings-large-text-toggle",
    highContrast: "settings-high-contrast-toggle",
    reduceMotion: "settings-reduce-motion-toggle",
    colorblind: "settings-colorblind-select",
    emailNotif: "settings-email-notifications-toggle",
    save: "settings-save-button",
  },
  jobs: {
    listRoot: "jobs-list-root",
    filterGenre: "jobs-filter-genre",
    filterBudget: "jobs-filter-budget",
    filterWords: "jobs-filter-words",
    filterTurnaround: "jobs-filter-turnaround",
    filterSpice: "jobs-filter-spice",
    filterSearch: "jobs-filter-search",
    filterApply: "jobs-filter-apply",
    filterClear: "jobs-filter-clear",
    newButton: "jobs-new-button",
    card: "jobs-card",
    createRoot: "jobs-create-root",
    fTitle: "jobs-new-title",
    fDescription: "jobs-new-description",
    fGenre: "jobs-new-genre",
    fWordCount: "jobs-new-wordcount",
    fBudgetMin: "jobs-new-budget-min",
    fBudgetMax: "jobs-new-budget-max",
    fTurnaround: "jobs-new-turnaround",
    fType: "jobs-new-type",
    fStyle: "jobs-new-style",
    createSubmit: "jobs-new-submit",
    detailRoot: "jobs-detail-root",
    detailEdit: "jobs-detail-edit",
    detailCancel: "jobs-detail-cancel",
    detailFund: "jobs-detail-fund",
    detailComplete: "jobs-detail-complete",
    applyOpen: "jobs-detail-apply",
    applyCoverLetter: "apply-cover-letter",
    applyRate: "apply-rate",
    applyTurnaround: "apply-turnaround",
    applySubmit: "apply-submit",
    applicationsList: "jobs-detail-applications",
    acceptApp: "application-accept",
    declineApp: "application-decline",
    myApplicationsRoot: "my-applications-root",
    withdrawApp: "application-withdraw",
    messageParticipant: "jobs-detail-message",
    manuscriptCard: "manuscript-card",
    manuscriptUpload: "manuscript-upload-input",
    manuscriptReplace: "manuscript-replace-input",
    manuscriptDownload: "manuscript-download",
    manuscriptRemove: "manuscript-remove",
    manuscriptGatedNote: "manuscript-gated-note",
  },
  messages: {
    root: "messages-root",
    threadItem: "messages-thread-item",
    threadRoot: "messages-thread-root",
    input: "messages-input",
    send: "messages-send",
  },
  reviews: {
    root: "reviews-root",
    open: "review-open",
    submit: "review-submit",
    body: "review-body",
  },
  payments: {
    statusPending: "escrow-status-pending",
    statusPaid: "escrow-status-paid",
  },
  coffeeChats: {
    root: "coffee-chats-root",
    invite: "coffee-chat-invite",
    accept: "coffee-chat-accept",
    decline: "coffee-chat-decline",
    complete: "coffee-chat-complete",
    inviteMessage: "coffee-chat-invite-message",
    inviteSubmit: "coffee-chat-invite-submit",
  },
  certifications: {
    root: "certifications-root",
    apply: "certification-apply",
    statement: "certification-statement",
    submit: "certification-submit",
  },
  favorites: {
    root: "favorites-root",
    card: "favorites-card",
    remove: "favorites-remove",
    empty: "favorites-empty",
  },
  stripeConnect: {
    card: "stripe-connect-card",
    onboard: "stripe-connect-onboard",
    demoBadge: "stripe-connect-demo-badge",
  },
};
